import React from 'react'
import Modal from './Modal'
import Avatar from './Avatar'
import { useFlowium } from '../client/FlowiumContext'
import type { WorkspaceMember } from '@flowium/client'
import { getDisplayLabel } from '../utils'

interface WorkspaceMembersModalProps {
  isOpen: boolean
  onClose: () => void
  workspaceId: string
}

const WorkspaceMembersModal: React.FC<WorkspaceMembersModalProps> = ({
  isOpen,
  onClose,
  workspaceId
}) => {
  const { client, currentWorkspace } = useFlowium()
  const [members, setMembers] = React.useState<WorkspaceMember[]>([])
  const [isLoading, setIsLoading] = React.useState(true)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const membersData = await client.getWorkspaceMembers(workspaceId)
        setMembers(membersData)
      } catch (err) {
        // silently handled
      } finally {
        setIsLoading(false)
      }
    }
    if (isOpen) fetchData()
  }, [isOpen, workspaceId])

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Workspace Members">
      <div className="bg-surface rounded-xl p-6 w-full max-w-[480px] mx-auto">
        <div className="mb-6">
          <p className="text-sm text-content-secondary">{getDisplayLabel(currentWorkspace?.name, 'Untitled workspace')}</p>
        </div>
        <div className="space-y-4">
          {isLoading ? (
            <p className="text-content-secondary">Loading members...</p>
          ) : (
            members.map((member) => (
              <div key={member.developer_id} className="flex items-center gap-3">
                <Avatar
                  label={member.email.charAt(0).toUpperCase()}
                  size={8}
                  color="#E2E8F0"
                />
                <div>
                  <p className="text-sm font-medium">{member.email}</p>
                  <p className="text-xs text-content-secondary">{member.is_owner ? 'Owner' : 'Member'}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </Modal>
  )
}

export default WorkspaceMembersModal
